@if (alarm | async; as alarm) {
  <div class="alarm-bar"
    [ngClass]="alarmClass | async"
    (click)="navigate()"
    angulartics2On="click"
    angularticsAction="alarmOrWarningClicked"
    angularticsCategory="installation">
    <img [src]="alarmStateToIconLink(alarm.type)">
    <div class="text-container">
      <div class="title">
        {{alarmTitle | async}}
      </div>
      <div>
        @if (showDetailedInfo | async) {
          <div>{{alarm.metadata | formatAlarmMetadata }}: {{alarm.metadata.title}}</div>
        }
      </div>
    </div>
    <div class="right">
      @if (showDetailedInfo | async) {
        <div>{{alarm.currentActivation.activatedTimestampEpoch | timeWithAgo}}</div>
      }
    </div>
  </div>
}
